import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getDashboardContractorCountList = createAsyncThunk(
  "dashboardContractorCountList/getDashboardContractorCountList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/contractor/dashboard`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const dashboardContractorCountSlice = createSlice({
  name: "dashboardContractorCountList",
  initialState: {
    loading: false,
    dashboardContractorCountData: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDashboardContractorCountList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDashboardContractorCountList.fulfilled, (state, action) => {
        state.loading = false;
        state.dashboardContractorCountData = action.payload;
      })
      .addCase(getDashboardContractorCountList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default dashboardContractorCountSlice.reducer;
